// extracted by mini-css-extract-plugin
export var container = "_j3-0";
export var content = "_j3-3";
export var customerTitle = "_j3-4";
export var empty = "_j3-5";
export var gray = "_j3-6";
export var header = "_j3-7";
export var info = "_j3-8";
export var loading = "_j3-2";
export var loadingCard = "_j3-9";
export var oneLine = "_j3-a";
export var personName = "_j3-e";
export var pillContainer = "_j3-b";
export var selected = "_j3-1";
export var text = "_j3-c";
export var twoLines = "_j3-d";
export var unread = "_j3-f";
export var unreadIndicator = "_j3-g";